
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faDiscord } from '@fortawesome/free-brands-svg-icons';
import { faTree } from "@fortawesome/free-solid-svg-icons"
import { faBars } from '@fortawesome/free-solid-svg-icons'
import './App.css';
//import Vector from "vectory-lib";
import Artwork from './pages/artwork';
import Superdrip from './pages/superdrip';
import Collection from './pages/collection';

import {
  TransitionGroup,
  CSSTransition
} from "react-transition-group";

import {
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import Banner from './component/banner';
import CanvasPage from './pages/canvas';
import CanvasItem from './pages/canvas-item';
import CanvasGallery from './pages/canvas-gallery';



function App() {

  const location = useLocation();
  const [navbarOpen, setNavbarOpen] = useState(false)
  const toggleMenu = () => {
    setNavbarOpen(!navbarOpen)
  };
  const closeMenu = () => {
    setNavbarOpen(false);
  }

  return (
    <div className="App">
      <div className="header">
        <Link to="/" onClick={closeMenu} title="Home" ><h1>0xDRIP</h1></Link>
        <div className="mobile-menu">
          <button onClick={toggleMenu}  className='mobile-menu-button'><FontAwesomeIcon className={`rotate-icon ${navbarOpen ? " rotate-me" : ""}`} icon={faBars} color="white"  /></button>
          <ul className={`mobile-menu-nav ${navbarOpen ? " show" : ""}`}>
            <li><Link to="/artwork" onClick={closeMenu} title="Artwork">Artwork</Link></li>
            <li><Link to="/superdrip" onClick={closeMenu} title="superDRIP">superDRIP</Link></li>
            <li><Link to="/collection" onClick={closeMenu} title="Collection">DRIP</Link></li>
            <li><Link to="/canvas" onClick={closeMenu} title="Collection">CANVAS</Link></li>
          </ul>
        </div>
      </div>
      <TransitionGroup component={null}>
          <CSSTransition
            classNames="fade"
            timeout={1000}
            key={location.key}
            unmountOnExit
          >
            <Routes location={location}>
                <Route 
                // @ts-ignore
                exact path="/" element={<Home />}>
                </Route>
                <Route path="/artwork" element={<Artwork />}>
                </Route>
                <Route path="/collection" element={<Collection />}>
                </Route>
                <Route path="/superdrip" element={<Superdrip />}>
                </Route>
                <Route path="/canvas" element={<CanvasPage />}>
                </Route>
                <Route path="/canvasitem" element={<CanvasItem />}>
                  <Route path=":canvasID" element={<CanvasItem />} />
                </Route>
                <Route path="/canvas/gallery" element={<CanvasGallery />}>
                </Route>
            </Routes>
      
      </CSSTransition>
        </TransitionGroup>
    <div className="content">
        <div className="social">
          <a rel="noreferrer" className="social-link discord" title="Discord" target="_blank" href="https://discord.gg/invite/7MfX2tvsKH">
            <FontAwesomeIcon icon={faDiscord} color="white" />
          </a>
          <a rel="noreferrer" className="social-link twitter" title="Twitter" target="_blank" href="https://twitter.com/0x_DRIP">
          <FontAwesomeIcon icon={faTwitter} color="white" />
          </a>
          <a rel="noreferrer" className="social-link linktree" title="Linktree" target="_blank" href="https://linktr.ee/0xdrip">
          <FontAwesomeIcon icon={faTree} color="white"  /></a>
        </div>
        <div className="links">
          <Link onClick={closeMenu} to="/artwork" title="Artwork">Artwork</Link>
          <Link onClick={closeMenu} to="/superDRIP" title="superDRIP">superDRIP</Link>
          <Link onClick={closeMenu} to="/collection" title="Collection">DRIP</Link>
          <Link onClick={closeMenu} to="/canvas" title="Collection">CANVAS</Link>
        </div>
      </div>
    
      </div>
  );
}


function Home() {
  /*
  useEffect(()=>{
    const config = {
      text: "0xDRIP",
      widthToSpikeLengthRatio: 0.01
    };

    const colorConfig = {
      particleOpacity: 0.52,
      baseHue: 150,
      hueRange: 5,
      hueSpeed: 0.04,
      colorSaturation: 100,
    };

    class Planet {
      constructor(x, y, g) {
        this.pos = new Vector(x, y);
        this.g = g;
      }
      
      draw() {
        ctx.fillStyle = "transparent";
        ctx.beginPath();
        ctx.arc(this.pos.x, this.pos.y, 8, 0, Math.PI * 2);
        ctx.fill();  
      } 
    }

    // A line that is part of forming the text
    class Particle {
      constructor(x, y) {
        this.pos = new Vector(x, y);
        this.vel = new Vector(0, spikeLength);
      }
      
      move(force) {
        if(force) {
          this.vel.addTo(force);
        }
        if(this.vel.getLength() > spikeLength) {
          this.vel.setLength(spikeLength);
        }
      }
        
      draw() {
        ctx.beginPath();
        ctx.moveTo(this.pos.x, this.pos.y);
        let p2 = this.pos.add(this.vel);
        ctx.lineTo(p2.x, p2.y);
        ctx.stroke();  
      }  
    }

    let canvas;
    let ctx;
    let w, h;
    let hue;
    let particles;
    let spikeLength;
    let planets;
    let A;
    let B;
    let a;
    let b;
    let tick;

    function setup() {
      tick = 0;
      planets = [];
      let len = 3;
      for(let i = 0; i < len; i++) {
        let p = new Planet(50 + i * 100, 340, i ? 1000 : 4000);
        planets.push(p);
      }
      canvas = document.querySelector("#canvas");
      ctx = canvas.getContext("2d");
      window.addEventListener("resize", reset);
      canvas.addEventListener("mousemove", mousemove);
      reset();
    }

    function reset() {
      hue = colorConfig.baseHue; 
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
      spikeLength = w * config.widthToSpikeLengthRatio;
      A = w / 2.2;
      B = h / 2.2;
      a = Math.round(Math.random() + 2);
      b = Math.round(Math.random() + 2);
      drawText();
    }

    function mousemove(event) {
      let x = event.clientX;
      let y = event.clientY;
      planets[0].pos.x = x;
      planets[0].pos.y = y;
    }

    function draw(now) {
      clear();
      requestAnimationFrame(draw);
      updateParticles();
      updatePlanets();
      tick = now / 50;
    }

    function clear() {
      ctx.clearRect(0, 0, w, h);
    }

    function drawText() {
      ctx.save();
      let fontSize = w * 0.2;
      ctx.font = "normal " + fontSize + "px RubikWet";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle"
      ctx.lineWidth = 1;
      ctx.strokeStyle = "white";
      ctx.strokeText(config.text, w/2, h/2);
      ctx.restore();
      let imageData = ctx.getImageData(0, 0, w, h);

      particles = [];

      for(let x = 0; x < w; x++) {
        for(let y = 0; y < h; y++) {
          let i = (x + w*y)*4;
          let average = (imageData.data[i] + 
                        imageData.data[i + 1] + 
                        imageData.data[i + 2] +
                        imageData.data[i + 3]) / 4;
          if(average > 200) {
            let particle = new Particle(x, y);
            particles.push(particle);
          }
        }
      }
      clear();
    }

    function updatePlanets() {
      let len = planets.length;
      for(let i = 1; i < len; i++) {
        let angle = Math.PI * 2 / (len - 1) * i;
        let x = A * Math.sin(a * tick / 100 + angle) + w/2;
        let y = B * Math.sin(b * tick / 100 + angle) + h/2; 
        let p = planets[i];
        p.pos.x = x;
        p.pos.y = y;
        p.draw();
      }
    }

    function updateParticles() {
      hue += colorConfig.hueSpeed; 
      let h = Math.sin(hue) * colorConfig.hueRange + colorConfig.baseHue;
      ctx.strokeStyle = `hsla(${h}, ${colorConfig.colorSaturation}%, 50%, ${colorConfig.particleOpacity})`;  
      particles.forEach(p => {
        // Apply the force of each planet (repeller) to the current particle
        planets.forEach(planet => {
          let d = p.pos.sub(planet.pos);
          let length = d.getLength();
          let g = planet.g / length;
          if(g > 40) {
            g = 40;
          }
          // We keep the angle of the distance
          d.setLength(g);
          p.move(d);
        });
        p.draw();
      });
    }

    setup();
    draw(1);


}, [])
<canvas id="canvas" style={{display: "none"}}></canvas>
*/
    return (
      <>
        <Banner/>
      </>
  )
}


export default App;
